import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  prevent(e) {
    if (e.key !== "Enter") return;
    if (e.target.type === "submit" || e.target.type === "textarea") return;

    e.preventDefault();
  }
}
